import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const currencySlice = createSlice({
  name: "currencies",
  initialState,
  reducers,
});

